import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDocumentDuplicate = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.5 3.25C7.5 2.2835 8.2835 1.5 9.25 1.5H11.1086C16.5715 1.5 21 5.92852 21 11.3914V16.25C21 17.2165 20.2165 18 19.25 18H16.5V20.75C16.5 21.7165 15.7165 22.5 14.75 22.5H4.75C3.7835 22.5 3 21.7165 3 20.75V7.75C3 6.7835 3.7835 6 4.75 6H7.5V3.25ZM7.5 7.5H4.75C4.61193 7.5 4.5 7.61193 4.5 7.75V20.75C4.5 20.8881 4.61193 21 4.75 21H14.75C14.8881 21 15 20.8881 15 20.75V18H9.25C8.2835 18 7.5 17.2165 7.5 16.25V7.5ZM19.5 11.3914V16.25C19.5 16.3881 19.3881 16.5 19.25 16.5H9.25C9.11193 16.5 9 16.3881 9 16.25V3.25C9 3.11193 9.11193 3 9.25 3H10.5133C10.9046 3 11.2922 3.07465 11.6554 3.21995L11.9288 3.32929C12.674 3.62737 13.2307 4.26517 13.4254 5.04381C13.4749 5.24208 13.5 5.44567 13.5 5.65003V7.25C13.5 8.2165 14.2835 9 15.25 9H16.3915C17.1292 9 17.8505 9.21837 18.4643 9.62759L18.607 9.72269C18.7168 9.79595 18.8192 9.87988 18.9126 9.97326C19.2887 10.3494 19.5 10.8595 19.5 11.3914ZM14.5 3.71353C14.6665 4.01442 14.7953 4.33877 14.8806 4.68001C14.9599 4.99725 15 5.32303 15 5.65003V7.25C15 7.38807 15.1119 7.5 15.25 7.5H16.3915C17.2443 7.5 18.0814 7.70822 18.8312 8.10301C17.9973 6.14723 16.4422 4.57269 14.5 3.71353Z",
		fill: "currentcolor"
	})]
});
export default SvgDocumentDuplicate;
